import { useEffect, useState } from "react";
import UpcomingVisits from "./UpcomingVisits";
import {
  generateBarCode,
  generateQrCode } from
"../../../services/qmatic/smartRegistration";
import { todayDate } from "../../../common/DateFormatters";
import StatusMessage from "./StatusMessage";

const PatientInfo = ({ ticketDetails, fetchQmaticInfo, translationMap }) => {
  const [showBarCode, setShowBarCode] = useState(true);
  const [barCode, setBarCode] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [error, setError] = useState("");

  const fetchBarCode = async () => {
    try {
      const ticketId = ticketDetails.ticketId;
      const response = await generateBarCode(ticketId);
      setBarCode(response.data.barcode);
    } catch (err) {
      setError("Error fetching barcode");
      setTimeout(() => setError(""), 5000);
      console.error("Error fetching barcode:", err);
    }
  };

  const fetchQrCode = async () => {
    try {
      const ticketId = ticketDetails.ticketId;
      const response = await generateQrCode(ticketId);
      setQrCode(response.data.qrcode);
    } catch (err) {
      setError("Error fetching QR code");
      setTimeout(() => setError(""), 5000);
      console.error("Error fetching QR code:", err);
    }
  };

  useEffect(() => {
    if (ticketDetails?.ticketId) {
      fetchBarCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketDetails, fetchQmaticInfo]);

  // eslint-disable-next-line no-unused-vars
  const handleToggleCode = async () => {
    if (showBarCode) {
      await fetchQrCode();
    } else {
      await fetchBarCode();
    }
    setShowBarCode(!showBarCode);
  };

  return (
    <>
      {ticketDetails && ticketDetails.ticketId ?
      <section className="w-100 clearfix" id="SmartResgistrationSection">
          <div className="SmartResgistrationSection">
            <div className="Title_Inner_Box">
              <h6 className="MainTitleOne">
                {ticketDetails.PatientFirstName}{" "}
                {ticketDetails.patientMiddleName}
                {ticketDetails.patientLastName}
              </h6>
            </div>
            <div className="inner_alert_box">
              <div className="AlertInnerBox AlertInnerBox2 BlueAlertInnerBox alert alert-dismissible fade show">
                <div className="Icon_box">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a>
                    <span className="material-symbols-outlined">info</span>
                  </a>
                </div>
                <div className="alert_text">
                  <p className="number_txt">{translationMap?.refreshToken}</p>
                </div>
              </div>
            </div>
            <div className="registration_inner_wrap">
              <div className="registration_inner_box">
                <div className="register_box1">
                  <p className="Gray_Title date_txt">{todayDate()}</p>
                  <h6 className="Gray_Titlen name_txt">
                    {ticketDetails.qmaticBranchName}
                  </h6>
                </div>
                {error && <h1>{error}</h1>}
                {showBarCode ?
              <div className="register_box2">
                    <img
                  src={`data:image/png;base64,${barCode}`}
                  alt="Displaying barcode" />
                
                  </div> :

              <div className="register_box2">
                    <img
                  src={`data:image/png;base64,${qrCode}`}
                  alt="Displaying qrcode" />
                
                  </div>
              }
                <div className="register_box1">
                  <h6 className="Gray_Titlen name_txt">
                    {ticketDetails.ticketId}
                  </h6>
                  <p className="Gray_Title date_txt">
                    {translationMap?.tokenText}
                  </p>
                </div>
                <div className="register_box1">
                  <h6 className="name_txt_pro">
                    {translationMap?.proceed}
                  </h6>
                  <p className="Gray_Title date_txt">
                    {ticketDetails.qmaticServiceName}
                  </p>
                </div>
                <div className="register_box3">
                  {/* <a className="blue_btn_link" onClick={handleToggleCode}>
                  {showBarCode ? "Show QR Code" : "Show Bar Code"}
                  </a> */}
                  {/* <a className="blue_btn_link">{translationMap?.showBarCode}</a> */}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                  className="bluetrans_btn_link"
                  onClick={() => {
                    window.parent.location.reload();
                    fetchQmaticInfo();
                    window.parent.scrollTo(0, 0);
                  }}>
                  
                    {translationMap?.refresh}
                  </a>
                </div>
                <UpcomingVisits
                nextVisitServices={ticketDetails.nextVisitServices}
                translationMap={translationMap} />
              
              </div>
            </div>
          </div>
        </section> :

      <StatusMessage translationMap={translationMap} />
      }
    </>);

};

export default PatientInfo;